export default "__VITE_ASSET__BHaYh8jb__"